const ZOOM_LEVELS = [15, 25, 50, 75, 100, 125, 150, 175, 200]

export function nextZoom(value: number, direction: 'in' | 'out') {
    const levels = direction === 'in' ? ZOOM_LEVELS : [...ZOOM_LEVELS].reverse()
    return (
        levels.find((level) => (direction === 'in' ? level > value : level < value)) ??
        Math.min(200, Math.max(15, value))
    )
}

export function pageNumber(value: string, total: number, current: number) {
    const number = Number(value)
    return Number.isFinite(number) && value.trim() ? Math.min(total, Math.max(1, Math.trunc(number))) : current
}
